(() => {
  function init(root = document) {
    root.querySelectorAll('[data-flavour-showcase]').forEach(showcase => {
      if (showcase.dataset.ready) return;
      showcase.dataset.ready = 'true';
      const tabs = [...showcase.querySelectorAll('[role="tab"]')];
      function choose(tab, focus = false) {
        tabs.forEach(item => {
          const active = item === tab;
          item.setAttribute('aria-selected', String(active));
          item.tabIndex = active ? 0 : -1;
          const panel = document.getElementById(item.getAttribute('aria-controls'));
          if (panel) panel.hidden = !active;
        });
        if (focus) tab.focus();
      }
      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => choose(tab));
        tab.addEventListener('keydown', event => {
          let next;
          if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
          if (event.key === 'ArrowLeft') next = (index - 1 + tabs.length) % tabs.length;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = tabs.length - 1;
          if (next === undefined) return;
          event.preventDefault();
          choose(tabs[next], true);
        });
      });
    });
    root.querySelectorAll('[data-variant-select]').forEach(select => {
      if (select.dataset.ready) return;
      select.dataset.ready = 'true';
      select.addEventListener('change', () => {
        const option = select.selectedOptions[0];
        const form = select.closest('form');
        const button = form.querySelector('[data-add]');
        form.querySelector('[data-price]').textContent = option.dataset.price;
        button.disabled = option.dataset.available !== 'true';
        button.textContent = button.disabled ? button.dataset.soldLabel : button.dataset.addLabel;
        const url = new URL(location.href);
        url.searchParams.set('variant', option.value);
        history.replaceState({}, '', url);
      });
    });
    const contact = root.querySelector('#ContactBody');
    if (contact && !contact.value) {
      const product = new URLSearchParams(location.search).get('product');
      if (product) contact.value = product + '\n\n';
    }
  }
  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    const menu = document.querySelector('.mobile-menu[open]');
    if (menu) { menu.open = false; menu.querySelector('summary').focus(); }
  });
  document.addEventListener('click', event => {
    const menu = document.querySelector('.mobile-menu[open]');
    if (menu && !menu.contains(event.target)) menu.open = false;
  });
})();
